import { closest } from '@syncfusion/ej2-base';
import { MultiSelect as EJ2MultiSelect } from '@syncfusion/ej2-dropdowns';
import { Base } from './base-module';
/**
 * The `MultiSelect` module is used configure the properties of Multi select type editor.
 */
export class MultiSelect {
    constructor(parent) {
        this.isPopOpen = false;
        this.compObj = undefined;
        this.parent = parent;
        this.parent.multiSelectModule = this;
        this.base = new Base(this.parent, this);
    }
    render(e) {
        const compModel = Object.assign({}, this.parent.model);
        this.openEvent = compModel.open;
        this.closeEvent = compModel.close;
        compModel.open = this.openHandler.bind(this);
        compModel.close = this.closeHandler.bind(this);
        this.compObj = new EJ2MultiSelect(compModel);
        this.compObj.appendTo(e.target);
    }
    openHandler(e) {
        this.isPopOpen = true;
        if (this.openEvent) {
            this.compObj.setProperties({ open: this.openEvent }, true);
            this.compObj.trigger('open', e);
        }
    }
    closeHandler(e) {
        this.isPopOpen = false;
        if (this.closeEvent) {
            this.compObj.setProperties({ close: this.closeEvent }, true);
            this.compObj.trigger('close', e);
        }
    }
    focus() {
        if (!this.isPopOpen) {
            const evt = document.createEvent('MouseEvent');
            evt.initEvent('mousedown', true, true);
            closest(this.compObj.element, '.e-multi-select-wrapper').dispatchEvent(evt);
        }
    }
    updateValue(e) {
        if (this.compObj && e.type === 'MultiSelect') {
            this.parent.setProperties({ value: this.compObj.value }, true);
            this.parent.extendModelValue(this.compObj.value);
        }
    }
    getRenderValue() {
        this.parent.printValue = this.compObj.text;
    }
    /**
     * Destroys the module.
     *
     * @function destroy
     * @returns {void}
     * @hidden
     */
    destroy() {
        this.base.destroy();
    }
    /**
     * For internal use only - Get the module name.
     *
     * @returns {string} - returns the string
     */
    getModuleName() {
        return 'multi-select';
    }
}
